import styled from 'styled-components'
import { colors, updatedSizes, updatedMedia } from 'client/styles'

import {
  Line,
  LineAdditionalFeesBase,
  PriceDetailsBase,
} from 'client/components/PriceDetails/styles'
import { HotelPreviewBase } from 'client/components/HotelPreview/styles'
import { CollapsibleSectionBase } from 'client/components/CollapsibleSection/styles'
import { AdditionalFeesBase } from 'src/comps/AdditionalFees/styles'
import { MobileOnlyBase } from 'src/comps/MobileOnlyPrice/styles'
import { PaymentInformationBase } from 'client/components/PaymentInformation/styles'
import { RoomCardBase } from '../BookingInformation/RoomCard/styles'
import {
  BookingInformationBase,
  BookingInformationHeader,
  Column,
} from '../BookingInformation/styles'
import { CancellationPoliciesBase } from '../CancellationPolicies/styles'

export const PriceDetailsContainer = styled.div`
  display: flex;
  border-radius: var(--radius-8);
  border: 2px solid ${colors.grey4};
  min-height: 245px;
  width: 100%;
  padding: var(--space-24);

  ${PriceDetailsBase} {
    width: 100%;
  }

  ${updatedMedia.mobile} {
    max-width: 400px;
  }
`

export const StaywalletContainer = styled.div`
  display: flex;
  border-radius: var(--radius-8);
  border: 2px solid ${colors.grey4};
  padding-block: 20px;
  padding-inline: 20px;
  width: 100%;
`

export const ContactDetailsContainer = styled.section`
  border-radius: var(--radius-8);
  border: 2px solid ${colors.grey4};
  width: 100%;
  padding-block: 20px;
  padding-inline: 20px;

  @media print {
    margin-block-start: 12px;
    padding-block: 12px;
    padding-inline: 12px;

    & > div a {
      padding-block: 0;
      padding-inline: 0;
    }
  }
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: wrap;
  width: 100%;
  margin-inline: 0;
  margin-block: 15px;
  ${props => props.hidden && 'display: none;'}

  ${PriceDetailsContainer} {
    margin-block: 15px 0;
    margin-inline: 0;
  }

  ${updatedMedia.tablet} {
    width: 100%;
    max-width: 1110px;
    margin-inline: auto;
    margin-block: auto;
    padding-block: 15px;
    padding-inline: 40px;
    flex-direction: row;
    align-items: flex-start;

    ${CollapsibleSectionBase} {
      align-items: unset;
    }

    ${PriceDetailsContainer} {
      margin-block: 0;
      margin-inline: 0;

      ${PriceDetailsBase} {
        background-color: transparent;
      }
    }

    ${HotelPreviewBase} {
      margin-block-end: 15px;
    }
  }

  ${updatedMedia.desktop} {
    gap: 16px;
    flex-wrap: nowrap;
  }

  @media screen and (max-width: ${updatedSizes.desktop - 1}px) {
    ${PriceDetailsContainer} {
      max-width: 100%;
    }

    ${HotelPreviewBase} {
      max-width: 100%;
      width: 100%;
    }
  }

  @media print {
    display: block;
    margin-block: 0;
    margin-inline: 0;

    & > div {
      padding-block: 12px;
      padding-inline: 12px;
      margin-inline: 0 !important;
      margin-block: 0 !important;
    }

    ${PriceDetailsContainer} {
      padding-block: 12px 0;
      padding-inline: 0;
    }
  }
`

export const RowHeader = styled(Row)`
  padding-block: 0;
  margin-block: 0;

  button {
    ${updatedMedia.tablet} {
      margin-block-start: 0;
    }
  }

  ${updatedMedia.tablet} {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
  }
`

export const ContactRow = styled(Row)`
  margin-inline: 0;
  margin-block: 0 15px;

  ${updatedMedia.tablet} {
    margin-block: 0;
    margin-inline: 0;
    padding-block-start: 0;
  }

  @media print {
    order: 1;
  }
`

export const CheckinSection = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1100px;
  border-radius: var(--radius-8);
  width: 100%;
  border: 2px solid ${colors.grey4};
  padding-block: 0;
  padding-inline: 20px;
`

export const CancelledBooking = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 21px;
  line-height: 25px;
  color: ${colors.red};
`

export const VoucherBase = styled.div`
  display: flex;
  flex-direction: column;
  margin-inline: 15px;
  margin-block: 0;
  max-width: 1100px;

  ${updatedMedia.tablet} {
    margin-inline: 20px;
    margin-block: 0;
  }

  ${updatedMedia.desktop} {
    margin-inline: auto;
    margin-block: auto;
  }

  @media print {
    margin-inline: 0;
    margin-block: 0;
    padding-block: 0;
    padding-inline: 0;
    max-width: none;

    & button {
      display: none;
    }

    & > ${Row} {
      padding-block: 0;
      padding-inline: 0;
      margin-block-end: 12px;
    }

    ${RowHeader} {
      display: none;
    }

    ${Line} {
      display: none;

      &:last-child {
        padding-block-end: auto;
      }
    }

    ${MobileOnlyBase} {
      display: none;
    }

    ${PaymentInformationBase} {
      display: none;
    }

    ${HotelPreviewBase} {
      max-width: 100%;
    }

    ${PriceDetailsContainer} {
      border: 0;
      max-width: 100%;
      min-height: 0;

      ${PriceDetailsBase} {
        width: 100%;
        padding-block: 0;
        padding-inline: 0;
      }

      ${AdditionalFeesBase} {
        border-width: 2px;
        margin-block: 0;
        margin-inline: 0;
      }
    }

    ${LineAdditionalFeesBase} {
      display: flex;
      max-width: 100%;
      border: 2px solid #e0e0e0;
      border-radius: var(--radius-8);
      padding-block: 12px;
      padding-inline: 12px;
    }

    ${BookingInformationBase} {
      display: block;
      & > div {
        display: block;
      }
    }

    ${RoomCardBase}, ${BookingInformationHeader}, ${CancellationPoliciesBase}, ${Column} {
      display: block;
      max-width: 100%;
      min-height: 0;
    }
  }
`
